/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PresenceRecentEditor
 */
export interface PresenceRecentEditor {
  /**
   *
   * @type {string}
   * @memberof PresenceRecentEditor
   */
  adminEmail: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof PresenceRecentEditor
   */
  lastEditedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the PresenceRecentEditor interface.
 */
export function instanceOfPresenceRecentEditor(
  value: object,
): value is PresenceRecentEditor {
  if (!("adminEmail" in value) || value["adminEmail"] === undefined)
    return false;
  if (!("lastEditedAt" in value) || value["lastEditedAt"] === undefined)
    return false;
  return true;
}

export function PresenceRecentEditorFromJSON(json: any): PresenceRecentEditor {
  return PresenceRecentEditorFromJSONTyped(json, false);
}

export function PresenceRecentEditorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PresenceRecentEditor {
  if (json == null) {
    return json;
  }
  return {
    adminEmail: json["adminEmail"],
    lastEditedAt: json["lastEditedAt"],
  };
}

export function PresenceRecentEditorToJSON(json: any): PresenceRecentEditor {
  return PresenceRecentEditorToJSONTyped(json, false);
}

export function PresenceRecentEditorToJSONTyped(
  value?: PresenceRecentEditor | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    adminEmail: value["adminEmail"],
    lastEditedAt: value["lastEditedAt"],
  };
}
